import { useEffect, useRef } from 'react';
import { Button } from './ui';
import { useT } from '../i18n';

/**
 * Infinite scroll: fetches the next page as the end of the list scrolls into view
 * (a little early, so it is usually there before the runner reaches it). The button
 * stays as a fallback if the observer does not fire.
 */
export function LoadMore({ hasMore, loading, onLoad }: { hasMore: boolean; loading: boolean; onLoad: () => void }) {
  const ref = useRef<HTMLDivElement>(null);
  const load = useRef(onLoad);
  load.current = onLoad;
  useEffect(() => {
    const el = ref.current;
    if (!el || !hasMore || loading || typeof IntersectionObserver === 'undefined') return;
    const io = new IntersectionObserver((entries) => entries.some((e) => e.isIntersecting) && load.current(), { rootMargin: '600px 0px' });
    io.observe(el);
    return () => io.disconnect();
  }, [hasMore, loading]);
  const t = useT();
  if (!hasMore) return null;
  return (
    <div ref={ref} className="mt-3" data-testid="load-more">
      <Button variant="secondary" className="w-full" onClick={onLoad} loading={loading}>
        {t('Load more')}
      </Button>
    </div>
  );
}
